import downloadBtns from "../data/downloadBtns";
import product from "../data/product";
import { isMobile } from "@/util/util";

export default {
    data() {
        return {
            downloadBtns,
            product,
            starList: [],
            more: {
                picture: require('../../../assets/images/download_star_more@2x.png'),
                name: '更多',
            },
            download_image: ''
        }
    },

    created() {
        if(isMobile()) {
            location.href = this.$link + '/download'
        }
        this.getDownloadInfo();
        this.getStarList();
    },

    methods: {
        getDownloadInfo() {
            this.$post('api.php/Home/down').then(res => {
                if(res.status === 1) {
                    this.download_image = res.data.blend || '';
                    this.downloadBtns.map(item => {
                        item.image = res.data[item.key] || '';
                    })
                }
            })
        },

        // 获取热门明星列表
        getStarList() {
            this.$post('api.php/Home/shareStar').then(res => {
                if(res.status == 1) {
                    this.starList = res.data || [];
                }
            })
        },


        openPage(data) {
            this.$router.push({
                name: 'star'
            })
        }
    }
}
